import { useQuery } from '@tanstack/react-query';
import { getApiV1Delft3dOrchestrationsByOrchestrationId } from '../api/generated/sdk.gen';
import { useAccessToken } from '../auth/AccessTokenContext';
import { queryKeys } from './queryKeys';

export const useFetchOrchestration = (
  orchestrationId: string | null | undefined,
) => {
  const token = useAccessToken();

  return useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: queryKeys.orchestration(orchestrationId as string),
    queryFn: async () => {
      if (!orchestrationId) return null;

      const response = await getApiV1Delft3dOrchestrationsByOrchestrationId({
        path: {
          orchestrationId,
        },
      });
      return response.data?.data || null;
    },
    enabled: !!token && !!orchestrationId,
    // Poll every 10s while orchestration is running but not yet in
    // Simulation phase (e.g. during Preprocessing). Once the phase
    // transitions to Simulation, progress polling takes over.
    refetchInterval: (query) => {
      const data = query.state.data;
      if (
        data?.phase_status === 'Running' &&
        data?.current_phase !== 'Simulation'
      ) {
        return 10000;
      }
      return false;
    },
  });
};
